'use client';

var _excluded = ["direction", "style", "unmountOnExit", "in", "className", "transition", "transitionEnd", "delay", "motionProps"];
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { TRANSITION_EASINGS, getSlideTransition, withDelay } from "./chunk-6NHXDBFO.mjs";

// src/slide.tsx
import { cx } from "@chakra-ui/shared-utils";
import { AnimatePresence, motion } from "framer-motion";
import { forwardRef } from "react";
import { jsx } from "react/jsx-runtime";
var defaultTransition = {
  exit: {
    duration: 0.15,
    ease: TRANSITION_EASINGS.easeInOut
  },
  enter: {
    type: "spring",
    damping: 25,
    stiffness: 180
  }
};
var variants = {
  exit: function exit(_ref) {
    var direction = _ref.direction,
      transition = _ref.transition,
      transitionEnd = _ref.transitionEnd,
      delay = _ref.delay;
    var _a;
    var _getSlideTransition = getSlideTransition({
        direction: direction
      }),
      exitStyles = _getSlideTransition.exit;
    return _objectSpread(_objectSpread({}, exitStyles), {}, {
      transition: (_a = transition == null ? void 0 : transition.exit) != null ? _a : withDelay.exit(defaultTransition.exit, delay),
      transitionEnd: transitionEnd == null ? void 0 : transitionEnd.exit
    });
  },
  enter: function enter(_ref2) {
    var direction = _ref2.direction,
      transitionEnd = _ref2.transitionEnd,
      transition = _ref2.transition,
      delay = _ref2.delay;
    var _a;
    var _getSlideTransition2 = getSlideTransition({
        direction: direction
      }),
      enterStyles = _getSlideTransition2.enter;
    return _objectSpread(_objectSpread({}, enterStyles), {}, {
      transition: (_a = transition == null ? void 0 : transition.enter) != null ? _a : withDelay.enter(defaultTransition.enter, delay),
      transitionEnd: transitionEnd == null ? void 0 : transitionEnd.enter
    });
  }
};
var Slide = forwardRef(function Slide2(props, ref) {
  var _props$direction = props.direction,
    direction = _props$direction === void 0 ? "right" : _props$direction,
    style = props.style,
    unmountOnExit = props.unmountOnExit,
    isOpen = props["in"],
    className = props.className,
    transition = props.transition,
    transitionEnd = props.transitionEnd,
    delay = props.delay,
    motionProps = props.motionProps,
    rest = _objectWithoutProperties(props, _excluded);
  var transitionStyles = getSlideTransition({
    direction: direction
  });
  var computedStyle = Object.assign({
    position: "fixed"
  }, transitionStyles.position, style);
  var show = unmountOnExit ? isOpen && unmountOnExit : true;
  var animate = isOpen || unmountOnExit ? "enter" : "exit";
  var custom = {
    transitionEnd: transitionEnd,
    transition: transition,
    direction: direction,
    delay: delay
  };
  return /* @__PURE__ */jsx(AnimatePresence, {
    custom: custom,
    children: show && /* @__PURE__ */jsx(motion.div, _objectSpread(_objectSpread({}, rest), {}, {
      ref: ref,
      initial: "exit",
      className: cx("chakra-slide", className),
      animate: animate,
      exit: "exit",
      custom: custom,
      variants: variants,
      style: computedStyle
    }, motionProps))
  });
});
Slide.displayName = "Slide";
export { Slide };